import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: 'var(--neutral-white)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid var(--border-light)',
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
    }}>
      <nav className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 40px',
        maxWidth: '87.5rem',
        margin: '0 auto'
      }}>
        {/* Logo */}
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none'
        }}>
          <img 
            src="/logo.jpg" 
            alt="Vitta Finance Academy" 
            style={{
              height: '55px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </Link>

        {/* Desktop Navigation */}
        <div style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center'
        }} className="desktop-nav">
          <Link to="/" className="nav-link" style={{
            color: isActive('/') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Home
          </Link>
          <Link to="/books" className="nav-link" style={{
            color: isActive('/books') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Books
          </Link>
          <Link to="/courses" className="nav-link" style={{
            color: isActive('/courses') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Courses
          </Link>
          <Link to="/interactive-books" className="nav-link" style={{
            color: isActive('/interactive-books') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Interactive Guides
          </Link>
          <Link to="/diagnostic-tool" className="nav-link" style={{
            color: isActive('/diagnostic-tool') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <span style={{
              background: 'var(--accent-gold)',
              color: 'var(--text-primary)',
              padding: '2px 8px',
              borderRadius: '4px',
              fontSize: '0.7rem',
              fontWeight: 600
            }}>FREE</span>
            Diagnostic
          </Link>
          <div className="nav-dropdown" style={{ position: 'relative' }}>
            <Link to="/institutional" className="nav-link" style={{
              color: isActive('/institutional') || isActive('/educational-institutes') ? 'var(--brand-primary)' : 'var(--text-secondary)',
              textDecoration: 'none',
              padding: '0.75em 1.25em',
              fontWeight: 500,
              fontSize: '1rem',
              transition: 'color 0.3s ease'
            }}>
              Institutional
            </Link>
            <div className="dropdown-menu" style={{
              position: 'absolute',
              top: '100%',
              left: '0',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              minWidth: '220px',
              padding: '8px 0',
              opacity: 0,
              visibility: 'hidden',
              transform: 'translateY(10px)',
              transition: 'all 0.2s ease',
              zIndex: 100
            }}>
              <Link to="/institutional" style={{
                display: 'block',
                padding: '12px 20px',
                color: '#334155',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: 500,
                transition: 'background 0.2s'
              }}>
                Corporate & Firms
              </Link>
              <Link to="/educational-institutes" style={{
                display: 'block',
                padding: '12px 20px',
                color: '#334155',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: 500,
                transition: 'background 0.2s'
              }}>
                Colleges / Universities
              </Link>
              <Link to="/norquest-college" style={{
                display: 'block',
                padding: '12px 20px',
                color: '#334155',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: 500,
                transition: 'background 0.2s'
              }}>
                Norquest College
              </Link>
              <Link to="/corporate-discounts" style={{
                display: 'block',
                padding: '12px 20px',
                color: '#334155',
                textDecoration: 'none',
                fontSize: '0.95rem',
                fontWeight: 500,
                transition: 'background 0.2s'
              }}>
                Corporate Discounts
              </Link>
            </div>
          </div>
          <Link to="/blog" className="nav-link" style={{
            color: isActive('/blog') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Blog
          </Link>
          {/* TEMPORARILY HIDDEN - Unhide in 2 days
          <Link to="/about" className="nav-link" style={{
            color: isActive('/about') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            About
          </Link>
          */}
          <Link to="/contact" className="nav-link" style={{
            color: isActive('/contact') ? 'var(--brand-primary)' : 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '0.75em 1.25em',
            fontWeight: 500,
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            Contact
          </Link>
          <a href="https://vittafinance.mykajabi.com/login" target="_blank" rel="noopener noreferrer" className="btn-gold" style={{
            marginLeft: '10px'
          }}>
            Member Login
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="mobile-menu-btn"
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            color: 'var(--brand-primary)',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" style={{
          display: 'none',
          backgroundColor: 'var(--neutral-white)',
          padding: '20px',
          borderTop: '1px solid var(--border-light)'
        }}>
          <Link to="/" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Home
          </Link>
          <Link to="/books" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Books
          </Link>
          <Link to="/courses" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Courses
          </Link>
          <Link to="/interactive-books" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Interactive Guides
          </Link>
          <Link to="/diagnostic-tool" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            <span style={{
              background: 'var(--accent-gold)',
              color: 'var(--text-primary)',
              padding: '2px 8px',
              borderRadius: '4px',
              fontSize: '0.7rem',
              fontWeight: 600
            }}>FREE</span>
            Diagnostic Tool
          </Link>
          <Link to="/institutional" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Institutional
          </Link>
          <Link to="/educational-institutes" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '12px 12px 12px 24px',
            fontSize: '1rem'
          }}>
            Colleges / Universities
          </Link>
          <Link to="/norquest-college" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '12px 12px 12px 24px',
            fontSize: '1rem'
          }}>
            Norquest College
          </Link>
          <Link to="/corporate-discounts" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            padding: '12px 12px 12px 24px',
            fontSize: '1rem'
          }}>
            Corporate Discounts
          </Link>
          <Link to="/blog" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Blog
          </Link>
          {/* TEMPORARILY HIDDEN - Unhide in 2 days
          <Link to="/about" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            About
          </Link>
          */}
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)} style={{
            display: 'block',
            color: 'var(--text-primary)',
            textDecoration: 'none',
            padding: '12px',
            fontSize: '1.125rem'
          }}>
            Contact
          </Link>
          <a href="https://vittafinance.mykajabi.com/login" target="_blank" rel="noopener noreferrer" className="btn-gold" style={{
            marginTop: '20px',
            width: '100%'
          }}>
            Member Login
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 767px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
          .mobile-menu {
            display: block !important;
          }
        }

        .nav-link:hover {
          color: var(--brand-primary) !important;
        }
      `}</style>
    </header>
  );
};

export default Header;
